import { DestroyRef, Injectable, PLATFORM_ID, inject, Injector } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { ConsentService } from '../../consent/consent.service';

@Injectable({ providedIn: 'root' })
export class NativeShellService {
  private readonly destroyRef = inject(DestroyRef);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly injector = inject(Injector);

  initialize(): void {
    if (!isPlatformBrowser(this.platformId) || !Capacitor.isNativePlatform()) {
      return;
    }

    void this.configureNativeShell();

    void App.addListener('resume', () => {
      void this.configureNativeShell();
      if (Capacitor.getPlatform() === 'ios') {
        void this.injector.get(ConsentService).syncFromAtt({ requestIfNeeded: false });
      }
    }).then((handle) => {
      this.destroyRef.onDestroy(() => {
        void handle.remove();
      });
    });
  }

  private async configureNativeShell(): Promise<void> {
    try {
      const overlayWebView = Capacitor.getPlatform() === 'ios';
      await StatusBar.setOverlaysWebView({ overlay: overlayWebView });
      await StatusBar.show();
      await StatusBar.setStyle({ style: Style.Light });
    } catch {
      // Status bar plugin unavailable outside the native shell.
    }
  }
}
